import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectComponent } from './components/project/project.component';
import { IsAuthenticatedGuard } from '../authentication/guards/is-authenticated.guard';
import { TrackerModeGuard } from '../authentication/guards/tracker-mode.guard';

const routes: Routes = [
  {
    path: ':id',
    component: ProjectComponent,
    canActivate: [IsAuthenticatedGuard],
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'review',
        loadChildren: () => import('../discrepancies/discrepancies.module').then((m) => m.DiscrepanciesModule)
      },
      {
        path: 'tracker',
        loadChildren: () => import('../tracker/tracker.module').then((m) => m.TrackerModule),
        canActivate: [TrackerModeGuard]
      },
      {
        path: 'activity-log',
        loadChildren: () => import('../activity-log/activity-log.module').then((m) => m.ActivityLogModule)
      },
      {
        path: 'validation',
        loadChildren: () => import('../validation/validation.module').then((m) => m.ValidationModule)
      },
      {
        path: 'designer',
        loadChildren: () => import('../task-designer/task-designer.module').then((m) => m.TaskDesignerModule)
      },
      {
        path: 'metadata-curator',
        loadChildren: () => import('../algo-settings/algo-settings.module').then((m) => m.AlgoSettingsModule)
      },
      { path: 'overview', loadChildren: () => import('../overview/overview.module').then((m) => m.OverviewModule) },
      {
        path: '',
        loadChildren: () => import('../spa/spa.module').then((module) => module.SpaModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectRoutingModule {}
